<form
  *transloco="let t; read: 'widgets.numeric-metadata-field-selector'"
  cdkScrollable
  class="field-selector__wrapper"
  [formGroup]="form"
>
  <table
    #table
    mat-table
    [dataSource]="items.controls"
    cdkScrollable
    cdkDropList
    (cdkDropListDropped)="onDropped($event)"
    [cdkDropListDisabled]="isDragDisabled || isReadOnly"
  >
    <ng-container matColumnDef="no">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let dataItem">
        <xi-icon
          icon="drag_handle"
          class="grab"
          cdkDragHandle
          (mouseenter)="isDragDisabled = false"
          (mouseleave)="isDragDisabled = true"
        ></xi-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="field">
      <th mat-header-cell *matHeaderCellDef>{{ t('select-metadata') }}</th>

      <td mat-cell *matCellDef="let group">
        @if (canModifyField) {
          <ng-container [formGroup]="group">
            <xi-dropdown
              [placeholder]="t('select')"
              select="single"
              [data]="fieldSet"
              formControlName="fieldId"
            ></xi-dropdown>
          </ng-container>
        } @else {
          <span> {{ getFieldLongName(group) }} </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef>{{ t('chart-label') }}</th>

      <td mat-cell *matCellDef="let group" class="field-selector__label-cell">
        <ng-container [formGroup]="group">
          <xi-input-field
            [placeholder]="t('label')"
            [maxCharsAllowed]="{ max: 64, allowOvertype: false, errorMessage: '' }"
            formControlName="label"
          ></xi-input-field>
          @if (!group.get('useDisplayName').disabled) {
            <xi-checkbox
              [label]="t('use-metadata-display-name')"
              color="CX"
              formControlName="useDisplayName"
            ></xi-checkbox>
          }
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="min">
      <th mat-header-cell *matHeaderCellDef>{{ t('min') }}</th>

      <td mat-cell *matCellDef="let group">
        <ng-container [formGroup]="group">
          <xi-input-field
            [placeholder]="hasMinMax(group) ? '1' : t('n-a')"
            type="number"
            formControlName="min"
          ></xi-input-field>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="max">
      <th mat-header-cell *matHeaderCellDef>{{ t('max') }}</th>

      <td mat-cell *matCellDef="let group">
        <ng-container [formGroup]="group">
          <xi-input-field
            [placeholder]="hasMinMax(group) ? '100' : t('n-a')"
            type="number"
            formControlName="max"
          ></xi-input-field>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="scoring">
      <th mat-header-cell *matHeaderCellDef>
        {{ journeyMode ? t('display-as') : t('scoring-methodology') }}
      </th>

      <td mat-cell *matCellDef="let group">
        <ng-container [formGroup]="group">
          <xi-dropdown
            [placeholder]="t('select')"
            select="single"
            [data]="getScoringSet(group)"
            formControlName="scoring"
          ></xi-dropdown>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="box-size">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let group">
        <ng-container [formGroup]="group">
          @if (
            group.controls.scoring.value === 'top' || group.controls.scoring.value === 'bottom'
          ) {
            <xi-dropdown
              [placeholder]="t('n-a')"
              select="single"
              [data]="getBoxSizeSet(group)"
              formControlName="boxSize"
            ></xi-dropdown>
          }

          @if (
            group.controls.fieldId.value === 'sentimentScore' &&
            group.controls.scoring.value === 'percentage'
          ) {
            <xi-dropdown
              [placeholder]="t('select')"
              select="single"
              [data]="percentageSentiments"
              formControlName="percentageSentiment"
            ></xi-dropdown>
          }
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="show-on-timeline">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let group">
        <ng-container [formGroup]="group">
          <xi-checkbox
            [label]="t('show-on-timeline')"
            color="CX"
            formControlName="showOnTimeline"
          ></xi-checkbox>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="decimals">
      <th mat-header-cell *matHeaderCellDef>{{ t('decimals') }}</th>

      <td mat-cell *matCellDef="let group">
        <ng-container [formGroup]="group">
          <xi-dropdown
            select="single"
            [data]="decimalsSet"
            formControlName="decimals"
          ></xi-dropdown>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="color">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let group">
        <ng-container [formGroup]="group">
          <xi-color-picker
            [selectedColor]="group.controls.color.value"
            [preselectedColors]="projectPalette"
            (onColorChange)="group.controls.color.setValue($event.detail.color)"
          ></xi-color-picker>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <xi-icon-button
          icon="add_circle"
          (onClick)="onAddItem()"
          [disabled]="!canAddField"
          [tooltip]="{ text: canAddField ? t('add-field') : t('not-available-comparisons') }"
        ></xi-icon-button>
      </th>

      <td mat-cell *matCellDef="let group; let i = index" class="field-selector__action-cell">
        <xi-icon-button
          icon="cancel_circle"
          [disabled]="isReadOnly"
          (onClick)="onDeleteItem(i)"
        ></xi-icon-button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row"></tr>
  </table>

  <ng-template #naInput>
    <xi-input-field [placeholder]="t('n-a')" type="number" [disabled]="true"></xi-input-field>
  </ng-template>
</form>
